// extracted by mini-css-extract-plugin
export default {"text":"NotesTemplate_text__frquh","addText":"NotesTemplate_addText__35ooB","icon":"NotesTemplate_icon__AW7ZM","iconWithValue":"NotesTemplate_iconWithValue__b9L4v"};